import LINKS from '@/Module/Core/Constant/LINKS';

export const GUARDED_URLS: string[] = [
  LINKS.WORKSPACE.MAIN,
  LINKS.PROFILE.LIKE,
  LINKS.PROFILE.BOOKMARK,
  LINKS.PROFILE.INFORMATION,
  LINKS.PROFILE.DEFAULT,
];
